module.exports = __webpack_public_path__ + "static/Ntc-main-a177a9a467adf7e6e651a5ab1a15518d.jpg";